import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const menuItems = [
    { label: 'Forside', path: '/' },
    { label: 'Sangundervisning', path: '/undervisning' },
    { label: 'Bio', path: '/om-heidi' },
    { label: 'Min musik', path: '/musik' },
    { label: 'Galleri', path: '/galleri' },
    { label: 'Blog', path: '/blog' },
    { label: 'Book en tid', path: '/kontakt' },
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-sand-200/60 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-4 md:py-6">
        {/* Logo / Brand Centered */}
        <div className="relative flex items-center justify-between min-[1200px]:justify-center">
          {/* Empty spacer for mobile to center logo */}
          <div className="w-10 min-[1200px]:hidden"></div>

          <Link to="/" className="group flex flex-col items-center text-center">
            <span className="font-serif text-2xl md:text-3xl font-semibold tracking-wide text-black transition-colors group-hover:text-black/80">
              Heidi Svelmøe
            </span>
            <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-black/70 font-medium mt-1">
              Sang & Mindfulness
            </span>
          </Link>

          {/* Mobile Menu Button (< 1200px) */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="block min-[1200px]:hidden p-2 text-foreground/80 hover:text-black focus:outline-none"
            aria-label="Toggle menu"
          >
            <i className={`fa-light ${isOpen ? 'fa-xmark' : 'fa-bars'} text-2xl`} />
          </button>
        </div>

        {/* Desktop Navigation (>= 1200px) */}
        <nav className="hidden min-[1200px]:flex items-center justify-center gap-8 w-full border-t border-sand-200/40 mt-5 pt-4">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`relative py-1 text-sm uppercase tracking-wider font-medium transition-colors ${
                isActive(item.path)
                  ? 'text-black font-semibold'
                  : 'text-foreground/70 hover:text-black'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/kontakt"
            className="rounded-full bg-cta px-6 py-2 text-xs uppercase tracking-widest font-semibold text-clay-900 hover:bg-cta-hover transition-all hover:shadow-md active:scale-98 ml-4"
          >
            Book tid
          </Link>
        </nav>
      </div>

      {/* Mobile Menu Drawer (< 1200px) */}
      {isOpen && (
        <div className="min-[1200px]:hidden fixed inset-0 top-[73px] z-40 bg-white/95 backdrop-blur-lg transition-all duration-300">
          <nav className="flex flex-col items-center justify-center h-[calc(100vh-120px)] gap-8 px-6">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-xl font-serif tracking-wide transition-colors ${
                  isActive(item.path)
                    ? 'text-black font-semibold'
                    : 'text-foreground/80 hover:text-black'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/kontakt"
              className="mt-4 rounded-full bg-cta px-8 py-3 text-sm uppercase tracking-widest font-semibold text-clay-900 hover:bg-cta-hover transition-all active:scale-98"
            >
              Book en tid
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
